import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import DateInput from 'components/Form/components/DateInput'
import styles from '../../BeneficiaryDisplayForm.scss'

class IndividualForm extends Component {
    static propTypes = {
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
    }

    render() {
      const {
        schema, form, handleChange, handleValidation, handleFocus,
      } = this.props
      return (
        <div className={styles.fieldset}>
          <li>
            <TextInput
              {...schema.firstName}
              error={form.firstName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.firstName.value}
              valid={form.firstName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.lastName}
              error={form.lastName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.lastName.value}
              valid={form.lastName.valid}
            />
          </li>
          <li>
            <DateInput
              {...schema.dob}
              disablePast={false}
              error={form.dob.error}
              handleChange={handleChange}
              valid={form.dob.valid}
              value={form.dob.value}
            />
          </li>
        </div>
      )
    }
}

export default IndividualForm



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/components/Beneficiary/IndividualForm.js